var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/check-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0016 50.3991C40.3727 50.3991 50.4016 40.3703 50.4016 27.9991C50.4016 15.6279 40.3727 5.59912 28.0016 5.59912C15.6304 5.59912 5.60156 15.6279 5.60156 27.9991C5.60156 40.3703 15.6304 50.3991 28.0016 50.3991ZM38.7999 22.9343C39.4821 21.9963 39.2747 20.6829 38.3367 20.0008C37.3988 19.3186 36.0854 19.526 35.4032 20.464L25.6487 33.8764L20.3865 28.6142C19.5664 27.7941 18.2367 27.7941 17.4166 28.6142C16.5965 29.4343 16.5965 30.7639 17.4166 31.584L24.4166 38.584C24.8509 39.0183 25.4535 39.2407 26.0658 39.1927C26.6781 39.1446 27.2387 38.831 27.5999 38.3343L38.7999 22.9343Z",
    fill: "#00B574"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreen);
export default __webpack_public_path__ + "static/media/CheckCircleGreen.03a59c018c664c93ec1d98f29d03f153.svg";
export { ForwardRef as ReactComponent };